// extracted by css-extract-rspack-plugin
export default {"body":"MMt_J","content":"vJJrH","scrollable":"NK2af"};